<script lang="ts">
import { sanitizeRichTextHtml } from '$lib/utils/sanitise';
import Link from '../../atoms/Link/Link.svelte';

let { items = [], animate = false, ...rest } = $props();

const animationOpts = ({ index }: { index: number }) => {
    return animate
        ? {
              'data-aos': 'fade-right',
              'data-aos-delay': 150 * index,
          }
        : {};
};
</script>

<ul class="linklist" {...rest}>
    {#each items as item, index (index)}
        <li
            class="linklist__item"
            class:item--active={item.active}
            {...animationOpts({ index: index })}
        >
            <Link to={item.to} target={item.target} onClick={item.onClick} active={item.active}>
                {#snippet text()}
                    {@html sanitizeRichTextHtml(item.text)}
                {/snippet}
            </Link>
        </li>
    {/each}
</ul>

<!--
////
////
////
    DON'T ADD STYLING HERE AS YOU'LL BE FOREVER
    OVERRIDING THE IMPLEMENTATION COMPONENTS!
    THIS COMPONENT IS JUST A MARKUP HELPER.
////
////
////
-->
